import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { DistanceMatrixService } from "@react-google-maps/api";
import websiteIcon from "../../../assets/images/icons/website.svg";
import directionsIcon from "../../../assets/images/icons/directions.svg";
import nationalInfoIcon from "../../../assets/images/icons/national.svg";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const BlueToolTip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#0016C7;",
    fontFamily: "Work Sans, sans",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: 0.5,
    padding: 10
  }
}))(Tooltip);

const SearchResult = props => {
  const {
    result,
    currentLocation,
    selectedResult,
    mapRef,
    setSelectedMarker
  } = props;

  const [currentDistance, setCurrentDistance] = useState({
    totalDistance: 0
  });

  const [resultSelected, setResultSelected] = useState(false);

  const directionsClickHandler = result => {
    let query =
      "https://www.google.com/maps/dir/" +
      currentLocation.lat +
      "," +
      currentLocation.lng +
      "/" +
      result[1].Latitude +
      "," +
      result[1].Longitude;
    window.parent.postMessage({ directions: query }, "*");
	// console.log(query);
  };

  const websiteClickHandler = url => {
    window.parent.postMessage({ url: url }, "*");
	 // console.log(url);
  };

  const resultClickHandler = () => {
    let lat = result[1].Latitude;
    let lng = result[1].Longitude;
    mapRef.current.panTo({ lat, lng });

    setSelectedMarker(result[1].ID, false);
  };
  
   const resultClickHandlerlogo = () => {
    console.log("res", result);
    if (result != "") {
      let dataLayer = [];
      dataLayer.push({
        event: "pfPharmacyFinderResults",
        pfPharmacyFinderResults: {
          pharmacyName: `Organization: ${result[1].Name}`, //queried zip code
          pharmacyID: `${result[1].ID} zip: ${result[1].Zip}` //true or false,
        }
      });
      var event = new CustomEvent("pfAnalytics", {
        detail: dataLayer
      });
      document.querySelector("body").dispatchEvent(event);
    }
  };

  const resultClickHandler1 = () => {
    console.log("res", result);
    if (result != "") {
      let dataLayer = [];
	  let email_id = `Email: `
      dataLayer.push({
        event: "pfPharmacyFinderResults",
        pfPharmacyFinderResults: {
          pharmacyName: email_id + " " + `${result[1].Name}`, //queried zip code
          pharmacyID: `${result[1].ID} zip: ${result[1].Zip}` //true or false,
        }
      });
      var event = new CustomEvent("pfAnalytics", {
        detail: dataLayer
      });
      document.querySelector("body").dispatchEvent(event);
    }
  };
  
  const resultClickHandler2 = () => {
    console.log("res", result);
    if (result != "") {
      let dataLayer = [];
	  let call = `Telephone: `
      dataLayer.push({
        event: "pfPharmacyFinderResults",
        pfPharmacyFinderResults: {
          pharmacyName: call + " " + `${result[1].Name}`, //queried zip code
          pharmacyID: `${result[1].ID} zip: ${result[1].Zip}` //true or false,
        }
      });
      var event = new CustomEvent("pfAnalytics", {
        detail: dataLayer
      });
      document.querySelector("body").dispatchEvent(event);
    }
  };
  
  const resultClickHandler3 = () => {
    console.log("res", result);
    if (result != "") {
      let dataLayer = [];
	  let Website = `Website: `
      dataLayer.push({
        event: "pfPharmacyFinderResults",
        pfPharmacyFinderResults: {
          pharmacyName: Website + " " + `${result[1].Name}`, //queried zip code
          pharmacyID: `${result[1].ID} zip: ${result[1].Zip}` //true or false,
        }
      });
      var event = new CustomEvent("pfAnalytics", {
        detail: dataLayer
      });
      document.querySelector("body").dispatchEvent(event);
    }
  };
  
  const resultClickHandler4 = () => {
    console.log("res", result);
    if (result != "") {
      let dataLayer = [];
	  let Direction = `Direction: `
      dataLayer.push({
        event: "pfPharmacyFinderResults",
        pfPharmacyFinderResults: {
          pharmacyName: Direction + " " + `${result[1].Name}`, //queried zip code
          pharmacyID: `${result[1].ID} zip: ${result[1].Zip}` //true or false,
        }
      });
      var event = new CustomEvent("pfAnalytics", {
        detail: dataLayer
      });
      document.querySelector("body").dispatchEvent(event);
    }
  };

  useEffect(() => {
    if (selectedResult.id === result[1].ID) {
      setResultSelected(true);
    } else {
      setResultSelected(false);
    }
  }, [selectedResult]);

  // useEffect(() => {
  //   console.log(result);
  // }, [result]);

  return (
    <div
      className={`searchResult ${
        selectedResult.id === result[1].ID ? "selected-result" : ""
      } `}
      onClick={() => {
        resultClickHandler();
      }}
    >
      <div className={"topRow"}>
        {currentLocation ? (
          <div className="distance">
            {currentDistance.totalDistance + "les"}
          </div>
        ) : null}

        {result[1].Type === "National" ? (
          <div className="nationalIcon">
            <img
              alt="White star on gradient background"
              src={nationalInfoIcon}
            />
          </div>
        ) : null}

        <div className={"resultName"}>{result[1].Name}</div>
        <div className="logoWrapper" onClick={() => {
        resultClickHandlerlogo();
      }}>
          <img
            alt="Logo of the organization in the area"
            className="logo"
            src={result[1].LogoImage}
          />
        </div>

        {currentLocation ? (
          <DistanceMatrixService
            options={{
              destinations: [
                { lat: result[1].Latitude, lng: result[1].Longitude }
              ],
              origins: [{ lng: currentLocation.lng, lat: currentLocation.lat }],
              unitSystem: window.google.maps.UnitSystem.IMPERIAL,
              travelMode: "DRIVING"
            }}
            callback={res => {
              if (currentDistance.totalDistance === 0) {
                setCurrentDistance({
                  totalDistance: res.rows[0].elements[0].distance.text
                });
              }
            }}
          />
        ) : null}
      </div>

      <div className={"bottomRow"}>
        <ul className="textRow">
          <li>{result[1].Address}</li>
          <li>
            {result[1].City + ", " + result[1].State + " " + result[1].Zip}
          </li>
          {result[1].Telephone === "N/A" ? null : (
            <li className={"resultTelephone"}>
              <a
                className="hover-underline-animation"
                href={"tel:" + result[1].Telephone}
				onClick ={()=> resultClickHandler2()}
              >
                {result[1].Telephone}
              </a>
            </li>
          )}
          {result[1].Email === "N/A" ? null : (
            <li className={"resultEmail"}>
              <a
                className="hover-underline-animation"
                target={"_blank"}
                rel="noopener noreferrer"
                href={"mailto:" + result[1].Email}
				onClick ={()=> resultClickHandler1()}
              >
                {result[1].Email}
              </a>
            </li>
          )}
        </ul>
        <ul className="buttonRow">
          <BlueToolTip title="WEBSITE" placement="bottom" arrow>
            <Button onClick={() => websiteClickHandler(result[1].Website)}>
              <img alt="White world wide web icon" src={websiteIcon} onClick ={()=> resultClickHandler3()}/>
            </Button>
          </BlueToolTip>
          <span>&nbsp;</span>
          {currentLocation ? (
            <BlueToolTip
              className="directionsBtn"
              title="DIRECTIONS"
              placement="bottom"
              arrow
            >
              <Button onClick={() => directionsClickHandler(result)}>
                <img alt="Map directions icon" src={directionsIcon} onClick ={()=> resultClickHandler4()}/>
              </Button>
            </BlueToolTip>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

export default SearchResult;
